<div class="main new" *ngIf="!seenBefore">New</div>
<div class="main previously-seen" *ngIf="seenBefore">Previously Seen</div>
